import HorariosPrestadores from "../../../pages/HorariosPrestadores/HorariosPrestadores";
import EstudiosPaciente from "../../../pages/Estudios/EstudiosPaciente";
import TurnosPaciente from "../../../pages/TurnosPaciente/TurnosPaciente";
import PageError from "../../../pages/PageError/PageError";
import MainPage from "../../../pages/MainPage/MainPage";
import NuevoTurno from "../../../pages/NuevoTurno/NuevoTurno";
import "./ExploreContainer.css";
import { Suspense } from "react";

interface ContainerProps {
  name: string;
}

const ExploreContainer: React.FC<ContainerProps> = ({ name }) => {
  return (
    <div className="container">
      <div className="container">
        <Suspense fallback={<div>Cargando...</div>}>
          {(() => {
            switch (name) {
              case "Estudios":
                return <EstudiosPaciente />;
              case "Turnos":
                return <TurnosPaciente />;
              case "Horarios":
                return <HorariosPrestadores />;
              case "Reservar turno":
                return <NuevoTurno />;
              case "Inicio":
                return <MainPage />;
              default:
                return <PageError motivo="404" />;
            }
          })()}
        </Suspense>
      </div>
    </div>
  );
};

export default ExploreContainer;
